import { FC } from "react";
import { FlexCol, FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";

import { useWebTranslation } from "translations";
import { Container } from "ui-kit/Layout";
import styles from "./Competitor.module.css";
import { amountSuffix } from "utils/insurance";
import classNames from "classnames";
import {
  getCompetitorMonthlyAmount,
  getCompetitorName,
  getCompetitorVetCareAmount,
  isManyPetsMultipleAnimals,
} from "../utils/insurely/insurelyUtil";
import { Insurely } from "components/Signup/store/state/types/insurely";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";

interface CompetitorProps {
  state: Insurely;
}

const Competitor: FC<CompetitorProps> = ({ state }) => {
  const { t } = useWebTranslation();

  const { name } = useCurrentAnimal();

  const competitorName = getCompetitorName(state);
  const competitorPrice = getCompetitorMonthlyAmount(state);
  const competitorVetCare = getCompetitorVetCareAmount(state);
  // insurely doesn't return correct price if you have group discount (manypets)
  const manyPetsMultipleAnimals = isManyPetsMultipleAnimals(state);

  return state.shouldCompare ? (
    <Container wide>
      <FlexCol alignItems="center" className={styles.container}>
        <FlexRow
          justifyContent="center"
          alignItems="center"
          className={styles.content}
        >
          <FlexRow
            justifyContent="center"
            className={classNames(styles.item, styles.price)}
          >
            <Typography>
              {`${t("quote_preview.competitor_insurance", {
                name: name ?? "",
                competitorName: competitorName ?? "",
              })}:`}
            </Typography>
            {manyPetsMultipleAnimals ? (
              <Typography>-</Typography>
            ) : (
              <div>
                <Typography>{competitorPrice}</Typography>{" "}
                <Typography color="grey400">{amountSuffix(1)}</Typography>
              </div>
            )}
          </FlexRow>
          <FlexRow className={classNames(styles.item, styles.divider)}>
            <Gutter size={1} horizontal />
            <Typography color="grey300">|</Typography>
            <Gutter size={1} horizontal />
          </FlexRow>
          <FlexRow justifyContent="center" className={styles.item}>
            <Typography>{`${t(
              "quote_preview.competitor_limit"
            )}: ${competitorVetCare}`}</Typography>
          </FlexRow>
        </FlexRow>
        {manyPetsMultipleAnimals && (
          <FlexRow
            justifyContent="center"
            alignItems="center"
            className={styles.content}
          >
            <Typography>
              {t("quote_preview.competitor_pricing_exclude_price_reason", {
                name: name ?? "",
              })}
            </Typography>
          </FlexRow>
        )}
      </FlexCol>
    </Container>
  ) : null;
};

export default Competitor;
